
import { Options, Vue } from 'vue-class-component';
import * as OM from '@/model';
import * as VM from '@/viewmodel';
import { WsServices } from '@/services/WsServices';
import { FileServices } from '@/services/FileServices';
import { ChatRoomClient } from '@/services/Services';
import store from '@/store';
import ImgPreviewModal from '@/components/chat/imgPreviewModal.vue';
import linkify from 'linkifyjs/html';
import { UploadServices } from '@/services/UploadServices';
import { Prop } from 'vue-property-decorator';

@Options({})
export default class chatContainer extends Vue {

    @Prop() chatRoom: OM.ChatRoom;

    intervalId: any;
    messages: OM.ChatMessage[] = [];
    quotedMessage: OM.QuotedMessage = null;
    messageText: string = "";
    showNuoviMessaggi: boolean = false;
    messageContainer: Element;
    scrollListenerOn: boolean;    
    fetchingData: boolean = false;
    doneFetching: boolean;
    take: number = 20;
    isCordova: boolean = false;
    chatWriter: HTMLDivElement = null;

    mountIt: boolean = false;

    created() {
        this.isCordova = window.cordova ? true : false;
    }
    
    mounted(){
        if(window.cordova){
            this.isIos = device.platform == "iOS";
            this.calcMessageContainerStyle();
            if(this.isIos){
                window.addEventListener('keyboardDidShow', this.scrollBottom);
            }
        }
        this.messageContainer = this.$refs.chatMessageContainer as HTMLDivElement;
        this.chatWriter = <HTMLDivElement>this.$refs.chatWriter;

        let parent = (this.$refs.rootElement as HTMLDivElement).parentElement;
        let parentHeight = parent.getBoundingClientRect().height;
        this.availableHeight = window.innerHeight - parentHeight - 70 + this.chatWriter.getBoundingClientRect().height;
        this.calcMessageContainerStyle();

        
        ChatRoomClient.getChatMessages(this.chatRoom.identifier, this.messages.length, this.take, true)
        .then(msgs => {
            this.messages = msgs;
            this.$nextTick( () => {
                this.messageContainer.scrollTop = this.messageContainer.scrollHeight;
                this.messageContainer.addEventListener('scroll', this.onTopScroll);
            });
            WsServices.connectToChatRoom(this.chatRoom.identifier, store.state.loginData.userIdentifier);
            WsServices.SetMessageListeners(this.onMessage, this.onDisable, this.onRemove);
        })
    }

    messageContainerStyle: string = "height: 0px;";
    availableHeight = 0;
    calcMessageContainerStyle(){
        setTimeout(() => {
            let ris = '';
            if(this.isIos)
                ris += '-webkit-overflow-scrolling: touch;';

            let finalHeight = this.availableHeight;

            let heightStyle = "";
            let writerHeight = this.chatWriter.getBoundingClientRect().height;
            finalHeight -= writerHeight;
            
            if(this.quotedMessage){
                let quotedContainer = document.querySelector('.chatWriter .quotedMessage');
                let quotedHeight = getComputedStyle(quotedContainer).height;
                finalHeight -= parseFloat(quotedHeight.substring(0, quotedHeight.length - 2));
            }

            heightStyle = `height: ${finalHeight}px`;
            ris += heightStyle;
            this.messageContainerStyle = ris;
        })
    }

    onWebAttachChange(ev) {
        var file = ev.target.files[0];
        var readerB64 = new FileReader();
        var self = this;
        var imgData = "";
        readerB64.readAsDataURL(file);
        readerB64.onloadend = function(){
            imgData = this.result.toString();

            self.$opModal.show(ImgPreviewModal, {
                imgPreview: imgData,
                okCb: () => { 
                    store.state.showSpinner++;
                    UploadServices.UploadFile({
                        file: file,
                        entityIdentifier: "",
                    })
                    .then( x => {
                        self.imgPreview = x.publicUrl;
                        self.sendImg(); 
                    }).finally(() => {
                        store.state.showSpinner--;
                    })
                }
            });
        }
    }

    showUploadActionBar: boolean = false;
    setShowUploadActionBar(){
        if(this.chatRoom.disabled)
            return;
        this.showUploadActionBar = true
    }
    imgPreview: string = '';
    getPic(from: number){
        let onSuccess = (imgData: any) => {
            if (window.cordova) {
                window.StatusBar.overlaysWebView(true);
                window.StatusBar.overlaysWebView(false);
            }
            this.showUploadActionBar = false;
            this.$opModal.show(ImgPreviewModal, {
                imgPreview: imgData,
                okCb: () => { 
                    store.state.showSpinner++;
                    FileServices.UploadCordovaChatImage(imgData)
                    .then( x => {
                        this.imgPreview = x.response.publicUrl;
                        this.sendImg(); 
                    })
                    .finally(() => store.state.showSpinner--)
                }
            });
        }
        let onError = (err: any) => {
            if (window.cordova) {
                window.StatusBar.overlaysWebView(true);
                window.StatusBar.overlaysWebView(false);
            }
            console.log(err);
        }
        (<any>window).navigator.camera.getPicture(onSuccess, onError, {
            destinationType: 1,
            sourceType: from,
            correctOrientation: true
        })
    }
    
    sendImg(){
        if(this.chatRoom.disabled) {
            return;
        }
        let newMessage: VM.SendMessageVm;
        if(store.state.loginData.userIdentifier){
            newMessage = {
                fromBackend: false,
                chatRoomIdentifier: this.chatRoom.identifier,
                text: `<div class="_chatImg" style="background-image: url(` + this.imgPreview + `), linear-gradient(rgba(0,0,0,0.9), rgba(0, 0, 0, 0.9));"></div>`,
                senderName: store.state.user.personalData.completeName,
                senderIdentifier: store.state.loginData.userIdentifier,
                clienteIdentifier: this.chatRoom.user.identifier,
                quotedMessage: this.quotedMessage
            }
        } else {
            newMessage = {
                fromBackend: false,
                chatRoomIdentifier: this.chatRoom.identifier,
                text: `<div class="_chatImg" style="background-image: url(` + this.imgPreview + `), linear-gradient(rgba(0,0,0,0.9), rgba(0, 0, 0, 0.9));"></div>`,
                senderName: "ospite",
                senderIdentifier: "",
                clienteIdentifier: this.chatRoom.user.identifier,
                quotedMessage: this.quotedMessage
            }
        }
        WsServices.SendMessage(newMessage);
        this.messageText = "";
        this.imgPreview = "";
        this.quotedMessage = null;
        this.calcMessageContainerStyle();
        this.$nextTick(() => {
            this.goToBottom();
        });
    }

    isIos = false;
    scrollBottom(){
        window.scrollTo(0,document.body.scrollHeight);
    }

    onLongtouch(val: OM.ChatMessage){
        this.quotedMessage = {
            sender: val.sender,
            text: val.text,
            fromBackend: val.fromBackend
        };
        this.$nextTick(() => {
            this.calcMessageContainerStyle();
        });
    }

    cancelQuote(){
        this.quotedMessage = null;
        this.calcMessageContainerStyle();
    }

    onTopScroll(){
        if(!this.isAtTop())
            return;
        if(this.fetchingData || this.doneFetching)
            return;
        this.fetchingData = true;
        ChatRoomClient.getChatMessages(this.chatRoom.identifier, this.messages.length, this.take, false)
        .then(msgs => {
            this.fetchingData = false;
            let scrollBottom = this.messageContainer.scrollHeight - this.messageContainer.scrollTop;
            this.messages.unshift(...msgs);
            this.$nextTick(() => {
                this.messageContainer.scrollTop = this.messageContainer.scrollHeight - scrollBottom;
            });
            if(msgs.length == 0){
                this.doneFetching = true;
                this.messageContainer.removeEventListener('scroll', this.onTopScroll);
            }
        })
    }
    
    beforeUnmount(){
        clearInterval(this.intervalId);
        this.messageContainer.removeEventListener('scroll', this.scrollListener);
        this.messageContainer.removeEventListener('scroll', this.onTopScroll);
        if(window.cordova){
            if(this.isIos){
                window.removeEventListener('keyboardDidShow', this.scrollBottom);
            }
        }
        WsServices.leaveChatRoom(this.chatRoom.identifier, store.state.user.identifier);
    }
    
    onMessage(message: OM.ChatMessage){
        this.messages.push(message);
        if(this.isAtBottom()){
            setTimeout(() => {
                this.goToBottom();
            }, 10);
        } else {
            //nuovi messaggi
            this.showNuoviMessaggi = true;
            this.scrollListenerOn = true;
            this.messageContainer.addEventListener('scroll', this.scrollListener);
        }
    }

    isAtTop(){
        return this.messageContainer.scrollTop == 0;
    }

    isAtBottom(){
        let a = Math.abs(Math.floor(this.messageContainer.clientHeight - this.messageContainer.scrollHeight));
        let b = Math.floor(this.messageContainer.scrollTop + 10);
        return a <= b;
    }
    scrollListener(){
        if(this.isAtBottom()){
            this.showNuoviMessaggi = false;
            this.scrollListenerOn = false;
            this.messageContainer.removeEventListener('scroll', this.scrollListener);
        }
    }
    onDisable(data: VM.WsDisableMessage){
        this.chatRoom.disabled = data.disable;
    }
    onRemove(data: VM.WsRemoveMessage){
        let index = this.messages.findIndex(x => x.identifier == data.messageIdentifier);
        this.messages.splice(index, 1);
        //(<any>this.$refs[data.messageIdentifier])[0].remove();
    }

    sendMessage(){
        if(!this.messageText.trim() || this.chatRoom.disabled) {
            return;
        }
        let parsedText = linkify(this.messageText);
        let newMessage: VM.SendMessageVm;
        if(!store.state.loginData.userIdentifier)
            return;

        newMessage = {
            fromBackend: false,
            chatRoomIdentifier: this.chatRoom.identifier,
            text: parsedText,
            senderName: store.state.user.personalData.completeName,
            senderIdentifier: store.state.loginData.userIdentifier,
            clienteIdentifier: this.chatRoom.user.identifier,
            quotedMessage: this.quotedMessage
        }
        WsServices.SendMessage(newMessage);
        this.messageText = "";

        this.calcMessageContainerStyle()
        this.quotedMessage = null;
        this.$nextTick(() => {
            this.goToBottom();
        });
    }

    goToBottom(){
        this.messageContainer.scrollTop = this.messageContainer.scrollHeight;
    }
}
